// Utilidades para periodos mensuales 'AAAA-MM' (Costos Cloud / Costos Proveedor).

export const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

// 'AAAA-MM' → 'Octubre 2026'
export const nombreMes = (periodo) => {
  const [y, m] = periodo.split('-').map(Number);
  return `${MESES[m - 1]} ${y}`;
};

// 'AAAA-MM' → 'Oct 26'
export const mesCorto = (periodo) => {
  const [y, m] = periodo.split('-').map(Number);
  return `${MESES[m - 1].slice(0, 3)} ${String(y).slice(2)}`;
};

// Periodo del mes actual (desplazamiento en meses: -1 = mes anterior).
export const periodoDesde = (desplazamiento = 0) => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() + desplazamiento);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// Suma meses a un periodo 'AAAA-MM'.
export const sumarMeses = (periodo, n) => {
  const [y, m] = periodo.split('-').map(Number);
  const d = new Date(y, m - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// 'AAAA-MM-DD' → '15 feb 2026'
export const fechaCorta = (fecha) => {
  const [y, m, d] = fecha.split('-').map(Number);
  return `${d} ${MESES[m - 1].slice(0, 3).toLowerCase()} ${y}`;
};

// Días entre hoy y una fecha 'AAAA-MM-DD' (negativo si ya pasó).
export const diasHasta = (fecha) => {
  const [y, m, d] = fecha.split('-').map(Number);
  const hoy = new Date();
  const base = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  return Math.round((new Date(y, m - 1, d) - base) / 86400000);
};
